import React, { useEffect } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { AnalyticType, setAnalyticUsersClicked } from "../../features/dataProcessingSlice";
import { Coordinates } from '../../features/searchSlice';
import { useCreateOrJoinAnalyticsGroupChatMutation } from '../../features/ChatSlice';
import { useAuthProfile } from '../../app/hooks';
import { useNavigate } from 'react-router-dom';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
//const haversine = require('haversine')

interface SummarizedAIProfileComponentProps {
    //children: ReactNode;    
    profileToShow: any
    aiSummary: any
    loggedInUserprofileCoordinates: Coordinates
    chatMode: boolean
}
export const SummarizedAIProfile: React.FC<SummarizedAIProfileComponentProps> = ({ profileToShow, aiSummary, loggedInUserprofileCoordinates, chatMode = false }) => {
    const dispatch = useDispatch<any>()
    const navigate = useNavigate()
    const [SetChat, { isLoading: isLoadingSetChat, isSuccess: isSuccessSetChat, isError: isErrorSetChat, data: setChatData, originalArgs //isError: isErrorSetChat, error: errorSetChat, reset 
    }] = useCreateOrJoinAnalyticsGroupChatMutation()
    const { authStatus, profile: profileLoggedIn, isLoading: isLoadingpProfileLoggedIn  // isLoading: isLoadingProfileLoggedIn, isError: isErrorProfileLoggedIn, error: errorProfileLoggedIn, userAttributesStateStatus 
    } = useAuthProfile()

    function userLink(analyticsVariable: string, analyticsArrayIndex: number, type: AnalyticType) {
        dispatch(setAnalyticUsersClicked({ analyticsArrayIndex: analyticsArrayIndex, analyticType: type, analyticsVariable: analyticsVariable }))
    }

    useEffect(() => {
        if (isSuccessSetChat) {//&& messagingReady) {
            //console.log("setChatData returned by useCreateOrJoinAnalyticsGroupChatMutation()", setChatData)
            // if( !messagingReady)
            //     dispatch(chatApi.util.invalidateTags(['Ready']))
            navigate("/Conversations", { state: { chatAndUserData: setChatData } })//navigate("/Messages", { state: { messageTo: profile.iam_id, id: profile.id } })
        }
        if (isErrorSetChat) {
            // Handle the error, and you can access originalArgs here
            //console.log('Original Args:', originalArgs); // Logs { id: 1, name: 'John Doe' }            
        }
    }, [isSuccessSetChat])


    if (aiSummary?.length > 0) {
        return (
            <Stack gap={1} sx={{ mt: 1 }}>
                {aiSummary.map((row: any, rowIndex: number) => {
                    const similarCount = row.analytics
                        ? (row.type === 'numeric' ? row.analytics?.users?.length : Array.isArray(row.analytics) ? row.analytics.length : 0)
                        : 0;
                    return (
                        <Box
                            key={row.var + "container" + rowIndex.toString()}
                            sx={{
                                border: '1px solid #EEEEEE',
                                borderRadius: 2,
                                p: 1.5,
                                backgroundColor: '#FAFAFA',
                            }}
                        >
                            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography variant="overline" sx={{ color: '#9E9E9E', fontSize: 10, letterSpacing: 1.1, lineHeight: 1.4, display: 'block' }}>
                                        {row.formattedVariable}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#1a1a2e', fontWeight: 500, lineHeight: 1.5 }}>
                                        {row.formattedValue}
                                    </Typography>
                                </Box>
                                {similarCount > 0 && (
                                    <Chip
                                        icon={<PeopleOutlineIcon sx={{ fontSize: 14, color: '#656EFF !important' }} />}
                                        label={`${similarCount} similar`}
                                        size="small"
                                        onClick={() => userLink(row.var, rowIndex, row.type)}
                                        sx={{
                                            mt: 0.5,
                                            flexShrink: 0,
                                            height: 24,
                                            fontSize: 11,
                                            fontWeight: 600,
                                            color: '#656EFF',
                                            backgroundColor: 'rgba(101, 110, 255, 0.08)',
                                            border: '1px solid rgba(101, 110, 255, 0.15)',
                                            cursor: 'pointer',
                                            '&:hover': { backgroundColor: 'rgba(101, 110, 255, 0.15)' },
                                            '& .MuiChip-icon': { ml: 0.5 },
                                        }}
                                    />
                                )}
                            </Stack>
                        </Box>
                    );
                })}
            </Stack>
        )
    } else {
        return (
            <Box sx={{
                border: '1.5px dashed rgba(101, 110, 255, 0.2)',
                borderRadius: '10px',
                py: 2.5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.75,
            }}>
                <ScienceOutlinedIcon sx={{ fontSize: 22, color: 'rgba(101, 110, 255, 0.25)' }} />
                <Typography variant="body2" sx={{ color: '#bbb', fontStyle: 'italic' }}>
                    No relevant story details were found
                </Typography>
            </Box>
        )
    }

}

